import { createBrowserClient } from '@supabase/ssr'

export function createClient() {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL
  const key = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

  // During Turbopack prerender of (client) components the env vars
  // aren't injected. `createBrowserClient('', '')` throws eagerly and
  // fails the build. Return a proxy that only throws when a caller
  // actually tries to use Supabase at render time — prerender just
  // walks the component tree for HTML and never hits `.auth.*` etc.,
  // so the page renders, Next auto-marks it dynamic via its own
  // cookies/headers checks, and the real client construction happens
  // in the browser where env vars are injected.
  if (!url || !key) {
    const err = new Error(
      '@supabase/ssr: Supabase env vars not available in this context. ' +
        'If this throws at runtime, NEXT_PUBLIC_SUPABASE_URL and ' +
        'NEXT_PUBLIC_SUPABASE_ANON_KEY need to be set.'
    )
    const stub: any = new Proxy(
      () => stub,
      {
        get() { throw err },
        apply() { throw err },
      }
    )
    return stub
  }

  return createBrowserClient(url, key)
}
